import { render, staticRenderFns } from "./TablaGrupoDocumentos.vue?vue&type=template&id=880033d8&"
import script from "./TablaGrupoDocumentos.vue?vue&type=script&lang=js&"
export * from "./TablaGrupoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports